// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4a-5";
export var imageContainer = "_4a-4";
export var metricsGrid = "_4a-2";
export var productDetailContainer = "_4a-1";
export var productListContainer = "_4a-0";
export var subscriberTableContainer = "_4a-3";